import $ from 'jquery'
import 'owl.carousel';
import { trace } from 'rytm-helpers';

let list = []

const getCarouselParamsResponsive = (el) => {
  switch (el.dataset.items) {
    case "2":
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
        576: {
          items: 2,
          // slideBy: "page",
        },
        768: {
          items: 2,
          // slideBy: "page",
        },
        992: {
          items: 2,
          // slideBy: "page",
        },
        1200: {
          items: 2,
          // slideBy: "page",
        },
      }
    case "3":
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
        576: {
          items: 2,
          // slideBy: "page",
        },
        768: {
          items: 2,
          // slideBy: "page",
        },
        992: {
          items: 3,
          // slideBy: "page",
        },
        1200: {
          items: 3,
          // slideBy: "page",
        },
      }
    default:
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
        380: {
          items: 2,
          // slideBy: "page",
        },
        768: {
          items: 3,
          // slideBy: "page",
        },
        992: {
          items: 4,
          // slideBy: "page",
        },
        1200: {
          items: 5,
          // slideBy: "page",
        },
      }
  }
}
const getCarouselParams = (el) => {
  const autoplay = el.dataset.autoplay ? true : false
  const autowidth = el.dataset.autowidth ? true : false
  const nav = el.dataset.hideNav ? false : true
  const sufix = el.dataset.navWhite ? "_white"  : "_black"
  const margin = el.dataset.margin ? parseInt(el.dataset.margin)  : 30
  return {
    nav,
    navText: [
      '<img src="/local/images/owl_arrow' + sufix + '_left.svg" alt="poprzedni" />', 
      '<img src="/local/images/owl_arrow' + sufix + '_right.svg" alt="następny" />'
    ],
    loop: false,
    // stagePadding: el.offsetWidth * .3,
    center: false,
    margin,
    dots: false,
    autoplay,
    slideTransition: "linear",
    autoplayTimeout: 3500,
    autoplayHoverPause: false,
    autoplaySpeed: 3500,
    autowidth,
    responsive: getCarouselParamsResponsive(el)
  }
}

const initOwlCarousel = (el, index) => {
  trace("init owl", el)
  let $carousel = $(el)
  $carousel.addClass('owl-carousel')
  $carousel.owlCarousel(getCarouselParams(el))
  list.push($carousel)
}
const destroyOwlCarousel = ($carousel, index) => {
  trace("destroy carousel", $carousel)
  $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
  $carousel.find('.owl-stage-outer').children().unwrap()
}

export const destroyOwl = () => {
  list.forEach(destroyOwlCarousel)
  list = []
}
export const buildOwl = () => {
  const list = [...document.querySelectorAll(".war-carousel")]
  list.forEach(initOwlCarousel)
}